import { ClassicCard } from '@braze/web-sdk';
import { Box, Flex, Image } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { ROUTES } from 'src/apps/invest/config';

type MessageCardProps = {
  card: ClassicCard;
};

export const MessageCard: React.FC<MessageCardProps> = ({ card }) => {
  return (
    <Flex
      alignItems={'center'}
      as={Link}
      to={ROUTES.inboxMessage(card?.id ?? '')}
      p={'24px'}
      borderWidth={'1px'}
      borderColor={'black'}
      gap={'20px'}
      justifyContent={'space-between'}
      cursor={'pointer'}
      position="relative"
      borderRadius={'10px'}
      _hover={{
        backgroundColor: 'gray.50',
        transition: 'all 0.2s ease-in-out',
      }}>
      {!card.viewed && !card.clicked && (
        <TextBlock
          position="absolute"
          top="-5px"
          left="10px"
          fontSize={'11px'}
          fontWeight={'bold'}
          fontFamily={FontFamily.HELVETICA_NOW_BOLD}
          backgroundColor={'blue.400'}
          borderRadius={'5px'}
          padding={'1px 6px'}
          color="white">
          New!
        </TextBlock>
      )}
      <Box alignItems={'center'} display="flex" justifyContent={'center'} maxWidth={'100px'}>
        {card.imageUrl ? (
          <Image src={card.imageUrl} borderRadius={'10px'} width={'100%'} />
        ) : (
          <Icon color={'gray.600'} fontSize={'20px'} icon="envelope" />
        )}
      </Box>
      <Box alignItems={'center'} display="flex" flex={1}>
        <TextBlock weight="bold" color={'black'}>
          {card.title}
        </TextBlock>
      </Box>
      <Icon fontSize={'24px'} icon="chevron-right" />
    </Flex>
  );
};
